import {guard} from 'effector';

import {doParseXml} from 'components/pages/DocumentsCreate/InvoiceNew/helpers/buildXml';
import {RestError, showRestError} from 'core/errors';

import {InvoiceLine} from 'types/invoices';

import {CreateInvoiceGate, setInvoiceState} from '../common';
import {
    addInvoiceLineValues,
    setInvoiceLinesHolder,
    setTaxesAndTotalFromXml,
    updateInfoValues,
    updatePageValues,
} from '../create';

import {
    fetchDataFx,
    commonData$,
    $everythingReady,
    $inlineInvoiceChargeModal,
    setInlineInvoiceChargeModal,
    $modalDuplicateLinesModal,
    setModalDuplicateLinesModal,
    $inlineModalFormReadonly,
    setInlineModalFormReadonly,
} from './index';

$inlineInvoiceChargeModal.on(setInlineInvoiceChargeModal, (_, data) => data);
$inlineModalFormReadonly.on(setInlineModalFormReadonly, (_, data) => data);

fetchDataFx.fail.watch(({error}) => showRestError(error as RestError));
$everythingReady.on(fetchDataFx.fail, () => true);

$modalDuplicateLinesModal.on(setModalDuplicateLinesModal, (_, data) => data);

guard({
    clock: setInvoiceState,
    filter: (i: string | null) => !!i && i !== 'new',
    target: fetchDataFx,
});

commonData$.on(fetchDataFx.doneData, (_, data) => data).reset(CreateInvoiceGate.close);
fetchDataFx.doneData.watch((p) => {
    const parsedXml = doParseXml(p);
    const {generalInformation, relatedDocuments, invoiceLines, taxes} = parsedXml['invoice'];

    updateInfoValues(generalInformation);
    updatePageValues(relatedDocuments);
    // setInvoiceLineChargeIndicator(invoiceLines.itemChargeIndicator);

    const inoviceLinesValues = Object.values(invoiceLines) as InvoiceLine[];
    const arrayReducedWithCombinedCodeId = inoviceLinesValues.reduce(
        (acc, i) => {
            const {combinedCodeId, ...rest} = i;
            if (combinedCodeId === undefined) {
                acc.array.push(rest);
                return acc;
            }

            const codeId = acc.combinedCodeIndexes[combinedCodeId];
            if (codeId !== undefined) {
                const {charges, vat, qty, price} = acc.array[codeId];
                const calcQty = Number(qty) + 1;
                const calcPrice = Number(price);
                const chargeAmount = charges
                    ? charges.amountXaf * (charges.isCharge === 'true' ? 1 : -1)
                    : 0;

                const lines = calcQty * calcPrice + chargeAmount;
                const lineAmountWVat = (Number(vat) / 100) * lines + lines;

                acc.array[codeId] = {
                    ...acc.array[codeId],
                    qty: calcQty.toString(),
                    lines: lines.toFixed(2),
                    lineAmountWVat: lineAmountWVat.toFixed(2),
                    combinedCodes: [...(acc.array[codeId]?.combinedCodes ?? []), rest.code ?? ''],
                };
            } else {
                acc.combinedCodeIndexes[combinedCodeId] = acc.array.length;
                const valueToArray = {
                    ...rest,
                    ...(rest.code && {combinedCodes: [rest.code]}),
                };
                acc.array.push(valueToArray);
            }

            return acc;
        },
        {
            array: [] as InvoiceLine[],
            combinedCodeIndexes: {} as Record<string, number>,
        },
    );

    addInvoiceLineValues(inoviceLinesValues);
    setInvoiceLinesHolder(arrayReducedWithCombinedCodeId.array);
    setTaxesAndTotalFromXml(taxes);
});
